@if (canUseActions) {
  <div class='actions-container text-center'>
    <label class='form-label actions-label mt-2' for='right-sidepanel-btns'>
      {{rightSidebarService.tab}} Actions
    </label>
    <div id='right-sidepanel-btns' class="btn-group btn-group-sm d-flex mb-2 ms-2 me-2 actions-btn-group" role="group">
      @if (canCopy) {
        <button type="button" class="btn btn-accent-success flex-fill" (click)="duplicate()">
          <i class="me-1 fa fa-plus fa-fw"></i>
          Duplicate
        </button>
      }
      @if (canCopy) {
        <button type="button" class="btn btn-accent-neutral flex-fill" (click)="copy()">
          <i class="me-1 fa fa-copy fa-fw"></i>
          Copy
        </button>
      }
      @if (canDelete && this.rightSidebarService.tab != 'Scene') {
        <button type="button" class="btn btn-accent-danger flex-fill" (click)="delete()">
          <i class="me-1 fa fa-trash fa-fw"></i>
          Delete
        </button>
      }
    </div>
    <div class="btn-group btn-group-sm d-flex mb-2 ms-2 me-2 actions-btn-group" role="group">
      @if (canDelete && this.rightSidebarService.tab == 'Scene') {
        <button type="button" class="btn btn-accent-danger flex-fill" (click)="delete()">
          <i class="me-1 fa fa-trash fa-fw"></i>
          Delete
        </button>
      }
    </div>
  </div>
}